/**
 * Created by LiuYang on 2017/11/14.
 */
import {
  map,
  each,
  flatten,
  keys,
  isFunction,
  isArray,
  isString,
  isObject,
  get,
  set,
  extend,
  partialRight,
  once,
  noop as AjaxModel
} from 'lodash';
import pathToRegexp from 'path-to-regexp';
import {
  studlyCase,
  addClass,
  removeClass,
  platform
} from 'src/common/Fn';
//import AjaxModel from './AjaxModel';

function mergeParams(routeList) {
  let index = routeList.length - 1;
  let current = null;
  let toRouter = extend({}, routeList[index]);
  while (current = routeList[--index]) {
    let inherit = get(current, 'meta.inherit');
    if(inherit || inherit === undefined ) {
      each(['headerInfo', 'bodyClassName', 'footerInfo'], function (item, idx) {
        let key;
        switch (item) {
          case 'headerInfo':
            key = 'meta.__headerFn';
            let currentHeaderFn = get(current, key);
            if( !get(toRouter, key) && currentHeaderFn) {
              set(toRouter,key, currentHeaderFn);
            }
            break;
          case 'bodyClassName':
            key = 'meta.bodyClassName';
            let toRouterClassName = get(toRouter, key, '');
            let currentBodyClassName = get(current, key, '');
            let newClassName = addClass(toRouterClassName, currentBodyClassName);
            set(toRouter, key, newClassName);
            break;
        }
      });
    }
  }
  return toRouter;
}

class BuildRoute {

  route;
  views;
  store;
  namespace;
  result;
  element;

  /**
   * 构建路由配置
   * @param route
   * @param views
   * @param Store
   * @param namespace
   * @param element
   */
  constructor(route, views,Store, namespace = false, element = document.body){
    this.route = route;
    this.views = views;
    this.element = element;
    this.store = Store;
    this.namespace = namespace
  }

  /**
   *
   * @returns {*}
   */
  toRouter(){
    if( this.result ) {
      return this.result;
    }
    let route = this.route;
    let views = this.views;
    let namespace = this.namespace;
    return namespace ? flatten(map(route, (item)=>this.buildRoute(item, views))) : this.buildRoute(route, views);
  }

  buildRoute(routes, views, parentPath){
    let itemKeys = keys(routes);
    let returnValue = [];
    for (let i = 0,current; current = itemKeys[i]; i++ ){
      let currentRouteConfig = routes[current];
      if (currentRouteConfig.parentPath === parentPath) {
        let defaultComponents = 'components' in currentRouteConfig ? currentRouteConfig.components : this.studlyCase(current);
        let defaultView = null;

        if ( isString(defaultComponents) ) {
          defaultView = {
            default: views[defaultComponents]
          };
        } else if ( isObject(defaultComponents) ) {
          defaultView = defaultComponents;
        }
        let currentRoute = {
          hidden: 'hidden' in currentRouteConfig ? currentRouteConfig.hidden : true,
          caseSensitive: !!currentRouteConfig.caseSensitive,
          name: 'name' in currentRouteConfig ? currentRouteConfig.name : current,
          _name: current,
          path: currentRouteConfig['path'],
          components: defaultView
        };
        if( !defaultView && !currentRouteConfig.redirect ) {
          console.warn(`can't find view ${current}`);
        }

        // 处理通用配置
        each({
          redirect: 'redirect',
          alias: 'alias',
          before: 'beforeEnter',
          props: 'props',
          meta: 'meta',
          alwaysShow: 'alwaysShow'
        }, (value, key)=>{
          if(currentRouteConfig[key]) {
            currentRoute[value] = isFunction(this[key]) ? this[key](currentRouteConfig[key]) : currentRouteConfig[key];
          }
        });

        // 处理头部及底部
        each({
          header: 'header',
          footer:'footer',
        }, (value, key)=>{
          let ret = this[key](currentRoute, currentRouteConfig[key], currentRouteConfig.meta || {});
          if(ret) {
            currentRoute.components[value] = ret;
          }
        });

        // 子路由
        let childrenView = this.buildRoute(routes, views, current);
        if(childrenView.length) {
          currentRoute.children = childrenView;
        }
        returnValue.push(currentRoute);
      }
    }

    return returnValue;
  }

  // 路由进入前置逻辑
  before(params){
    let parsedRoute = null;
    let self = this;
    let buildRoute = function (params, keys) {
      let returnArray = [];
      if( isArray(params) ) {
        let rule = map(params, (param)=>buildRoute(param));
        returnArray.push(function (to, from) {
          let current = null,
            i = 0,
            ret,
            callFn = function (fn) {
              return function(...data){
                return fn(to, from, ...data);
              };
            };
          while (current = rule[i]){
            i++;
            if ( !ret ){
              ret = current(to, from);
            } else {
              ret = ret.then(callFn(current));
            }
          }
          return ret;
        });
      } else if( params instanceof AjaxModel){
        returnArray.push(self.model(params, keys));
      } else if ( isFunction(params) ) {
        returnArray.push(params);
      } else if(isObject(params)){
        let result = map(params,  buildRoute);
        returnArray.push(function (to, from) {
          return Promise.all(map(result, (item)=>item(to, from)));
        });
      } else if( isString( params )) {
        if( params.indexOf(',') !== -1 ) {
          returnArray.push(buildRoute(params.split(',')));
        } else {
          let [ param, ignore ] = params.match(/([|\w:]+)(\?)?/).slice(1);
          let hasParams = params.indexOf(':') === -1 ? 'string' : 'regexp';
          let fn = null;
          if( hasParams === 'string' ) {
            if( BuildRoute.before[hasParams][param] ) {
              fn = BuildRoute.before[hasParams][param];
            }
          }
          if( !fn ){
            each(BuildRoute.before['regexp'], function (item, key) {
              let reg = new RegExp(key, 'i');
              let result;
              if(result = reg.exec(param)) {
                fn = partialRight(item, ...map(result.slice(1),(item)=>item.split('|')));
                return false;
              }
            })
          }
          if( !fn) {
            throw new Error(`can't find before ${param}`);
          }
          returnArray.push(function (to, from, ...arg) {
            return fn(to, from, !!ignore, ...arg);
          });
        }
      }
      if (returnArray.length === 1) {
        return returnArray[0];
      }
      return function (to, from, ...args) {
        return Promise.all(map(returnArray, item => item(to, from, ...args)));
      };
    };

    return function (to, from, next) {
      if ( parsedRoute === null) {
        parsedRoute = buildRoute(params);
      }
      parsedRoute(to, from).then((data)=>{
        next(data);
      }).catch((data)=>{
        if(data && data.redirect) {
          next(data.redirect);
        } else if(data === false) {
          next(false);
        }
      });
    };
  }

  // 路由进入Model处理
  model(model, keys){
    let isIgnore = false;
    if(isString(keys)) {
      isIgnore = keys.charAt(keys.length - 1) === '?'
    }
    let key = isIgnore ? keys.slice(0, -1) : keys;
    return function (to, from , params) {
      return model.execute(extend({}, to.query, to.params)).then((data) => {
        if(key) {
          to.params[key] = data;
        }
        return data;
      }).catch(function (err) {
        if( isIgnore ) {
          return Promise.resolve();
        } else {
          return Promise.reject(err);
        }
      });
    }
  }

  // 路由进入头部处理
  header(currentRoute, header, meta){
    let view;
    if(((meta.headerVisible === 'auto' || meta.headerVisible === undefined)  && !platform.isWeChat()) || meta.headerVisible === true) {
      view = this.views['Header'];
    }

    if(header && (meta.headerVisible || meta.headerVisible === undefined)) {
      let store = this.store;
      set(currentRoute, 'meta.__headerFn', function (to, from) {
        let headerInfo;
        if(isFunction(header)) {
          headerInfo = header(to, from);
        } else if(isObject(header)) {
          headerInfo = header;
        } else if(isString(header)) {
          headerInfo = {
            showHeader: false,
            title: header
          };
        }
        //store.dispatch('setHeader', headerInfo);
      });
    }

    return view;
  }

  // 路由进入底部处理
  footer(currentRoute, params, meta){
    let store = this.store;
    set(currentRoute, 'meta.__footerFn', function (to, from) {
      /*store.dispatch('setFooter', {
        showFooter: !!params
      });*/
    });
    return this.views['Footer'];
    // return params ? this.views['Footer'] : undefined;
  }

  // 路由进入重定向处理
  redirect(params){
    return params;
  }

  afterEach(to, from){
    let toRouter = mergeParams(to.matched);
    let fromRouter = mergeParams(from.matched);
    let meta = get(toRouter, 'meta', {});

    // 处理页面顶部
    let headerFn = meta.__headerFn;
    if(isFunction(headerFn)) {
      headerFn(to, from);
    }

    // 处理页面底部
    let footerFn = meta.__footerFn;
    if(isFunction(footerFn)) {
      footerFn(to, from);
    }

    // 处理body元素的class
    let removeClassName = get(fromRouter, 'meta.bodyClassName', '');
    let addClassName = meta.bodyClassName || "";
    let originClassName = (this.element.className || "");

    if (removeClassName) {
      originClassName = removeClass(originClassName, removeClassName);
    }
    if (addClassName) {
      originClassName = addClass(originClassName, addClassName);
    }

    this.element.className = originClassName;
  }

  studlyCase = studlyCase;

  static before = {
    'string': {},
    'regexp': {}
  };

  static after = {
    'string': {},
    'regexp': {}
  };

  static extend(anchor, name, callback){
    if ( ['before', 'after'].indexOf(anchor) === -1) {
      throw new Error('anchor not validate');
    }
    let key = name.indexOf(':') === -1 ? 'string': 'regexp';
    let currentAnchor = BuildRoute[anchor][key];

    if( key === 'regexp' ) {
      key = pathToRegexp(name).source;
    } else {
      key = name;
    }

    if ( currentAnchor[name] ) {
      console.warn(`${anchor} and ${name} has been defined`);
    }

    currentAnchor[key] = callback;
  }
}

export default BuildRoute;



// WEBPACK FOOTER //
// ./src/class/BuildRoute.js